














import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { IPolicy } from 'admiral-core';
import Weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/de';
import dayjs from 'dayjs';
import { mixins } from 'vue-class-component';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';
import { Util } from '@/utils/Util';
import { BaseMixin } from '@/mixins/BaseMixin';

dayjs.extend(Weekday);
dayjs.locale('de');

@Component({
  name: 'policy-short',
  components: { PolicyStatusBadge },
})
export default class PolicyShort extends mixins(BaseMixin) {
  @Prop({ type: Object, required: true })
  policy!: IPolicy;

  @Prop({ type: Boolean, required: false, default: true })
  small!: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  hovered!: boolean;

  get title() {
    return `${Util.formatPolicyStatus(this.policy.status)}: ${
      this.policy.product ? this.policy.product.name : 'Kein Produkt'
    } für ${this.policy.customer}`;
  }
}
